export default "__VITE_ASSET__DdqG7wzj__"